import React from 'react';
import ReportsContainer from "../containers/ReportsContainer";

const ReportsView = () => {

  return (
    <ReportsContainer/>
  );
};

export default ReportsView;
